<template>
  <div class="nav_list_small_screen">
    <collapse-header
      title_img="المادة 1"
      style="display: block; position: static; border-top: 1px solid #eee"
    >
      <b-list-group flush>
        <b-list-group-item to="/">الرئيسية</b-list-group-item>
        <b-list-group-item>عن المنظمة</b-list-group-item>
        <b-list-group-item
          :to="{ name: 'activities', params: { id: this.$route.params.id } }"
          >الأخبار</b-list-group-item
        >
        <b-list-group-item
          :to="{
            name: 'ngo-donation',
            params: { id: this.$route.params.id },
          }"
          >التبرع</b-list-group-item
        >
        <!-- <b-list-group-item style="padding: 0px">
          <app-collapse>
            <div class="list_sp">
              <app-collapse-item title="تشبيك" info="">
                <b-dropdown-item
                  :to="{
                    name: 'how-to-support-me',
                    params: { id: this.$route.params.id },
                  }"
                  >كيف يمكنك مساعدتي كمنظمة</b-dropdown-item
                >
                <hr class="m-0" />
                <b-dropdown-item
                  :to="{
                    name: 'how-to-get-support',
                    params: { id: this.$route.params.id },
                  }"
                  >كيف يمكنني مساعدتك
                </b-dropdown-item>
              </app-collapse-item>
            </div>
          </app-collapse>
        </b-list-group-item> -->
        <b-list-group-item
          :to="{
            name: 'ngo-events',
            params: { id: this.$route.params.id },
          }"
          >الفعاليات</b-list-group-item
        >
        <b-list-group-item style="padding: 0px">
          <app-collapse>
            <div class="list_sp">
              <app-collapse-item title="انضم إلينا" info="">
                <b-dropdown-item
                  :to="{
                    name: 'ngo-jobs',
                    params: { id: this.$route.params.id },
                  }"
                  >فرص العمل</b-dropdown-item
                >
                <hr class="m-0" />
                <b-dropdown-item
                  :to="{
                    name: 'ngo-volunteer',
                    params: { id: this.$route.params.id },
                  }"
                  >فرص تطوع</b-dropdown-item
                >
              </app-collapse-item>
            </div>
          </app-collapse>
        </b-list-group-item>
        <b-list-group-item style="padding: 0px">
          <app-collapse>
            <div class="list_sp">
              <app-collapse-item title="فريق العمل" info="">
                <b-dropdown-item
                  :to="{
                    name: 'ngo-founders',
                    params: { id: this.$route.params.id },
                  }"
                >
                  المؤسسين</b-dropdown-item
                >
                <hr class="m-0" />
                <b-dropdown-item
                  :to="{
                    name: 'ngo-admins',
                    params: { id: this.$route.params.id },
                  }"
                  >مجلس الإدارة</b-dropdown-item
                >
              </app-collapse-item>
            </div>
          </app-collapse>
        </b-list-group-item>
        <b-list-group-item
          :to="{
            name: 'ngo-contact-us',
            params: { id: this.$route.params.id },
          }"
          >تواصل معنا</b-list-group-item
        >
      </b-list-group>
    </collapse-header>
  </div>
</template>
<script>
import CollapseHeader from "../../../@core/components/app-collapse/CollapseHeader.vue";
import AppCollapse from "../../../@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "../../../@core/components/app-collapse/AppCollapseItem.vue";
import {
  BNav,
  BNavItem,
  BDropdown,
  BDropdownItem,
  BButton,
  BListGroupItem,
  BListGroup,
} from "bootstrap-vue";

export default {
  components: {
    //            FeatherIcon,
    BButton,
    BNav,
    BNavItem,
    BDropdown,
    BDropdownItem,
    BButton,
    // AppCollapseItem,
    CollapseHeader,
    BListGroupItem,
    BListGroup,
    AppCollapse,
    AppCollapseItem,
  },
};
</script>

<style lang="scss" scoped>
.header-button {
  margin: 0px 10px;
  align-items: center;
  span {
    margin: 0px 2px;
  }
}
.nav_list_small_screen {
  display: none;
}
.card {
  .card-header {
    .list-group-item {
      padding: 0px;
    }
  }
}
.card-body {
  li {
    display: flex;
  }
}
.collapse-icon [data-toggle="collapse"]::after {
}
@media (max-width: 1030px) {
  .nav_list_small_screen {
    display: inline;
  }
}
</style>
